import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
type Purchase = {
  name: string;
  city: string;
  flag: string;
  action: string;
  minutes: number;
};
const PURCHASES: Purchase[] = [{
  name: 'Valentina M.',
  city: 'Buenos Aires',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 3
}, {
  name: 'Martín G.',
  city: 'Córdoba',
  flag: '🇦🇷',
  action: 'se sumó al sistema',
  minutes: 7
}, {
  name: 'Carolina R.',
  city: 'Rosario',
  flag: '🇦🇷',
  action: 'acaba de acceder al Master Kit',
  minutes: 1
}, {
  name: 'Diego F.',
  city: 'Mendoza',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 2
}, {
  name: 'Luciana P.',
  city: 'La Plata',
  flag: '🇦🇷',
  action: 'se sumó',
  minutes: 11
}, {
  name: 'Sebastián T.',
  city: 'Mar del Plata',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 5
}, {
  name: 'Valeria H.',
  city: 'Tucumán',
  flag: '🇦🇷',
  action: 'acaba de descargar el sistema',
  minutes: 1
}, {
  name: 'Nicolás B.',
  city: 'Salta',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 4
}, {
  name: 'Florencia K.',
  city: 'Santa Fe',
  flag: '🇦🇷',
  action: 'se sumó',
  minutes: 9
}, {
  name: 'Gonzalo W.',
  city: 'Mendoza',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 6
}, {
  name: 'Romina S.',
  city: 'CABA',
  flag: '🇦🇷',
  action: 'acaba de acceder',
  minutes: 1
}, {
  name: 'Facundo L.',
  city: 'Córdoba',
  flag: '🇦🇷',
  action: 'se sumó',
  minutes: 18
}, {
  name: 'Agustina C.',
  city: 'Rosario',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 13
}, {
  name: 'Hernán D.',
  city: 'Buenos Aires',
  flag: '🇦🇷',
  action: 'se sumó',
  minutes: 3
}, {
  name: 'Jimena V.',
  city: 'Mar del Plata',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 16
}, {
  name: 'Florencia B.',
  city: 'Neuquén',
  flag: '🇦🇷',
  action: 'se sumó',
  minutes: 8
}, {
  name: 'Cecilia M.',
  city: 'San Juan',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 21
}, {
  name: 'Ramiro T.',
  city: 'Entre Ríos',
  flag: '🇦🇷',
  action: 'se sumó',
  minutes: 10
}, {
  name: 'Gabriela S.',
  city: 'Misiones',
  flag: '🇦🇷',
  action: 'acaba de acceder al sistema',
  minutes: 1
}, {
  name: 'Lucas P.',
  city: 'San Luis',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 15
}];
const getInitials = (name: string) => name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
const SHOW_INTERVAL = 15000; // cada 15 segundos
const VISIBLE_DURATION = 4000; // permanece 4 segundos
export const SocialProofPopup = () => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const showNext = () => {
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), VISIBLE_DURATION);
    };
    // Primer popup a los 4s de cargar la página
    const firstTimer = setTimeout(showNext, 4000);
    const cycleTimer = setInterval(() => {
      setIndex(prev => (prev + 1) % PURCHASES.length);
      showNext();
    }, SHOW_INTERVAL);
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(hideTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  const p = PURCHASES[index];
  return <div className="fixed top-3 right-3 z-[60] pointer-events-none" data-id="element-231">
      <AnimatePresence mode="wait" data-id="element-232">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        x: 40,
        y: -8
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: 40,
        y: -8
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} role="status" aria-live="polite" className="pointer-events-auto w-[268px] sm:w-[300px] bg-familia-section border border-familia-cyan/20 rounded-2xl shadow-[0_10px_30px_-8px_rgba(0,0,0,0.6)] px-3 py-3" data-id="element-233">
            <div className="flex items-start gap-3" data-id="element-234">
              {/* Avatar con bandera */}
              <div className="relative shrink-0" data-id="element-235">
                <div className="w-11 h-11 rounded-full bg-familia-gold text-familia-bg flex items-center justify-center font-bold text-sm" data-id="element-236">
                  {getInitials(p.name)}
                </div>
                <span className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-familia-card border border-white/10 flex items-center justify-center text-[11px] leading-none" data-id="element-237">
                  {p.flag}
                </span>
              </div>

              {/* Contenido */}
              <div className="flex-1 min-w-0" data-id="element-238">
                <div className="flex items-center gap-1.5 text-familia-gray text-[11px] mb-0.5" data-id="element-239">
                  <span className="text-[12px] leading-none" data-id="element-240">{p.flag}</span>
                  <span className="truncate" data-id="element-241">{p.city}</span>
                </div>
                <p className="text-white text-[12px] leading-snug" data-id="element-242">
                  <span className="font-bold" data-id="element-243">{p.name}</span> {p.action}
                </p>
                <div className="flex items-center gap-1.5 mt-1 text-familia-green text-[11px] font-semibold" data-id="element-244">
                  <ShoppingBagIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-245" />
                  <span data-id="element-246">Compra verificada</span>
                  <span className="text-familia-green/70" data-id="element-247">
                    • hace {p.minutes} minutos
                  </span>
                </div>
              </div>

              {/* Cerrar */}
              <button type="button" onClick={() => setVisible(false)} aria-label="Cerrar notificación" className="shrink-0 text-familia-gray hover:text-white transition-colors" data-id="element-248">
                <XIcon className="w-4 h-4" data-id="element-249" />
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};